/* eslint-disable react/prop-types */

import React, { forwardRef, useState, useEffect, useImperativeHandle, useRef } from 'react';
import { Rect } from 'react-konva';
import ShapeTransformer from './ShapeTransformer';
import Shape from './Shape';

// eslint-disable-next-line react/prop-types, react/display-name
const TransformableShape = forwardRef((props, ref) => {
  const shapeRef = useRef();
  const debug = false;
  useImperativeHandle(ref, () => ({
    getBoundingBox () { return getBoundingBox(); }
  }));

  const [boundingBox, setBoundingBox] = useState({ x: props.x, y: props.y, width: props.width, height: props.height, stroke: 'red', dash: [10, 5] });

  useEffect(() => {
    updateBoundingBox();
  }, [props]);

  const getBoundingBox = () => {
    const rect = shapeRef.current;
    const rectClientRect = rect.getClientRect();
    const absCenterX = rectClientRect.width / 2 + rectClientRect.x;
    const absCenterY = rectClientRect.height / 2 + rectClientRect.y;

    return {
      x: absCenterX - rectClientRect.width / 2,
      y: absCenterY - rectClientRect.height / 2,
      width: rectClientRect.width,
      height: rectClientRect.height,
      stroke: 'red',
      dash: [10, 5]
    };
  };

  // const handleChange = () => {
  //   updateBoundingBox();
  //   updateNote();
  // };

  const updateBoundingBox = () => {
    const boundingBox = getBoundingBox();
    setBoundingBox(boundingBox);
  };

  const handleTransformEnd = event => {
    // transformer is changing scale of the node
    // and NOT its width or height
    // but in the store we have only width and height
    // to match the data better we will reset scale on transform end
    const node = shapeRef.current;
    const scaleX = node.scaleX();
    const scaleY = node.scaleY();

    // we will reset it back
    node.scaleX(1);
    node.scaleY(1);
    // console.log('old size: ' + [node.width(), node.height()]);
    // console.log('new size: ' + [node.width() * scaleX, node.height() * scaleY]);

    props.onChange({
      ...props.shapeProps,
      x: node.x(),
      y: node.y(),
      // set minimal value
      width: Math.max(5, node.width() * scaleX),
      height: Math.max(node.height() * scaleY)
    });
    updateBoundingBox();
  };

  return (
        <React.Fragment>
          {debug && <Rect {...boundingBox} ></Rect> }
        <Shape
          {...props}
          type={props.type}
          ref={shapeRef}
          draggable
          // onDragMove={handleChange}
          onDragEnd={(e) => {
            props.onChange({
              ...props,
              x: e.target.x(),
              y: e.target.y()
            });
          }}
          onTransformEnd={handleTransformEnd}
        ></Shape>
        {props.isSelected && <ShapeTransformer
            shapeRef={shapeRef}
            isSelected={props.isSelected}
        />}
        </React.Fragment>
  );
});
export default React.memo(TransformableShape);
